import { render, staticRenderFns } from "./OfficerOpenRecruitmentPostShow.vue?vue&type=template&id=18838ddf&"
import script from "./OfficerOpenRecruitmentPostShow.vue?vue&type=script&lang=js&"
export * from "./OfficerOpenRecruitmentPostShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports